import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { CALL_FETCH_DOCUMENT_TYPES, FETCH_DOCUMENT_TYPES_SUCCESS, fetchDocumentTypesSuccess, fetchDocumentTypesFailed } from '../ducks/DocumentTypesDucks';
import DocumentTypesAPI from '../integrations/DocumentTypesAPI';
import { resize } from '../ducks/ApplicationDucks';

function* fetchDocumentTypes({ workflowInstanceId }) {
  try {
    const documentTypes = yield call(DocumentTypesAPI.fetchDocumentTypes, workflowInstanceId);
    yield put(fetchDocumentTypesSuccess(documentTypes));
  }
  catch(error) {
    yield put(fetchDocumentTypesFailed(error));
  }
}

function* fetchDocumentTypesSuccessSaga() {
  yield put(resize());
}

function* fetchDocumentTypesSagas() {
  yield takeLatest(CALL_FETCH_DOCUMENT_TYPES, fetchDocumentTypes);
}

function* fetchDocumentTypesSuccessSagas() {
  yield takeEvery(FETCH_DOCUMENT_TYPES_SUCCESS, fetchDocumentTypesSuccessSaga);
}

export default function* () {
  yield all([
    fork(fetchDocumentTypesSagas),
    fork(fetchDocumentTypesSuccessSagas)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/DocumentTypesSagas.js